<template>
	<div v-if="value || showNull" data-testid="price-display">
		<div class="whitespace-nowrap">
			<div v-if="showIncludedOptionsMessage" class="text-xs  mb-1">
				Preis inkl. von Ihnen gewählter Optionen
			</div>
			<div v-if="formattedBasePrice" class="line-through text-red-600 text-sm">
				Regulärer Preis: {{ formattedBasePrice }}
			</div>
			<span v-if="Math.sign(value) === -1">-</span>
			{{ formattedPositivePrice }}
		</div>
		<div v-if="slots.default">
			<slot></slot>
		</div>
	</div>
</template>

<script lang="ts" setup>
import {computed, useSlots} from "vue"

const props = withDefaults(defineProps<{
	value?: number
	currency?: string
	locale?: string
	showNull?: boolean
	basePrice?: number
}>(), {
	currency: "CHF",
	locale: "de-CH",
	showNull: false
})

const slots = useSlots()

const toCurrency = (value: number): string => {
	return new Intl.NumberFormat(props.locale, {
		style: "currency",
		currency: props.currency
	}).format(value)
}

const formattedBasePrice = computed((): string | null => {
	// Only show the base price if it's provided and strictly greater than the model value
	if (props.basePrice != null) {
		const positiveValue = props.value != null ? Math.abs(props.value) : 0
		if ((props.basePrice as number) > positiveValue) {
			return toCurrency(props.basePrice as number)
		}
	}
	return null
})

const showIncludedOptionsMessage = computed((): boolean => {
	if (props.basePrice == null) return false
	const positiveValue = props.value != null ? Math.abs(props.value) : 0
	return (props.basePrice as number) < positiveValue
})

const formattedPositivePrice = computed((): string | null => {
	if (props.value == null && !props.showNull) {
		return null
	}
	if (props.value == null) {
		return toCurrency(0)
	} else {
		const positiveValue = Math.abs(props.value as number)
		return toCurrency(positiveValue)
	}
})
</script>
